module.exports = __webpack_public_path__ + "img/plus.aff05490.svg";